import React, { useState } from "react";
import Icon from "../icons";
import { PrimaryButton } from "../Cta";
import { Input } from "../FormElements";

export default function UpiVerifyModal({
  value,
  error,
  handleChange,
  onKeyPress,
  close,
  onClick,
}) {
  const [localError, setLocalError] = useState(false);

  // ✅ Validation function
  const validateUpi = (upi) => {
    const upiRegex = /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/;
    return upiRegex.test(upi.trim());
  };

  const handleSubmit = () => {
    if (!validateUpi(value)) {
      setLocalError(true);
      return;
    }
    setLocalError(false);
    onClick(); // call parent submit
  };

  return (
    <div className=" position-fixed top-0 start-0 e-bg-modal min-h-100vh min-vw-100 d-flex align-items-center justify-content-center">
      <div className="row w-100">
        <div className="offset-lg-4 col-lg-4">
          <div className="bg-white e-border-radius-24 e-p-24px">
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-column row-gap-1">
                <h6 className=" e-font-weight-600 mb-0 e-font-20 e-text-eerie-black d-flex column-gap-2">
                  Verify bank with UPI
                  <span className="d-flex column-gap-1 align-items-center e-font-10 e-text-purple e-font-weight-400">
                    <Icon icon="thunder" size="13px" />
                    FASTEST
                  </span>
                </h6>
                <p className="e-secondary-font-Inter e-font-weight-400 e-font-16">
                  ₹1 for verification, instant refund
                </p>
              </div>
              <div className="d-flex align-items-start">
                <PrimaryButton
                  icon="close-button"
                  name=""
                  size="14px"
                  ClassName="bg-white p-1"
                  onPress={close}
                />
              </div>
            </div>

            {/* Input */}
            <div className="row">
              <Input
                id="1"
                type="text"
                label="Enter UPI ID"
                placeholder="Enter UPI ID here"
                require={true}
                value={value}
                error={localError}
                className="e-primary-font-poppins w-100"
                onKeyPress={onKeyPress}
                handleChange={handleChange}
                autoFocus={true}
              />
              {(localError || error) && (
                <p className="e-text-cg-red e-font-12 mt-1 mb-0">
                  {error
                    ? "Invalid Upi id"
                    : "Please enter a valid UPI ID (e.g. name@bank)"}
                </p>
              )}
            </div>

            {/* Button */}
            <div className="row pt-3">
              <div className="col-12">
                <PrimaryButton
                  ClassName="e-border-radius-pill py-3 e-font-weight-500 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
                  name="Link bank"
                  onPress={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
